// front/src/components/projects/ProjectRelated.jsx
import { Link } from 'react-router-dom';

export default function ProjectRelated({ related }) {
  if (!related || related.length === 0) return null;

  return (
    <section>
      <h2 className="h6 mb-3">Related projects</h2>
      <div className="list-group">
        {related.map((p) => (
          <Link
            key={p._id}
            to={`/projects/${p._id}`}
            className="list-group-item list-group-item-action d-flex align-items-center"
          >
            {p.coverImage && (
              <img
                src={p.coverImage}
                alt=""
                style={{
                  width: '48px',
                  height: '48px',
                  objectFit: 'cover',
                  borderRadius: '4px',
                  marginRight: '0.75rem',
                }}
              />
            )}
            <div>
              <div className="fw-semibold">{p.title}</div>
              {p.category && (
                <small className="text-muted">{p.category}</small>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
